import DecimalService from '../decimalService';

const multiplyNumbersAsDecimals = (a: number, b: number) => {
    const decimalA = DecimalService.parse(a);
    const decimalB = DecimalService.parse(b);
    const product = DecimalService.multiply(decimalA, decimalB);

    return DecimalService.toNumber(product);
};

export default multiplyNumbersAsDecimals;
